export enum SopStepRichVariant {
  CONTACT_HELP = "contact-help"
}
